module.exports = __webpack_public_path__ + "img/close.41f05f5e.svg";